import { clsx } from 'clsx';

import type { IconProps } from 'components/Icon';

import styles from './StatusPill.module.css';

import { Icon } from 'components/Icon';

export interface StatusPillProps {
  /** The status to convey. */
  status: 'possible' | 'impossible' | 'new';
  /** The variant of the pill. */
  variant?: 'default' | 'bar';
  /** A description of the status. */
  label: string;
}

const iconNameMap: Partial<Record<StatusPillProps['status'], IconProps['name']>> = {
  possible: 'CheckCircleFillMini',
  impossible: 'CrossCircleFillMini',
};

/** Represents a component for a status pill. */
export function StatusPill({ status, variant = 'default', label }: StatusPillProps) {
  return (
    <span
      className={clsx(
        styles['status-pill'],
        styles[`status-pill__${status}`],
        variant !== 'default' && styles[`status-pill--${variant}`]
      )}
    >
      {status !== 'new' && <Icon name={iconNameMap[status]!} title={status} size={16} />}
      {label}
    </span>
  );
}
